import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stepper } from 'syf-component-library/ui/patterns';
import { FAR_CHECK } from '../../../../const/iconProps';
import { t } from '../../../../strings/i18n';
import { StepperWrapper } from '../subcomponents';
const PaymentStepper = ({ step }) => {
    const detailsLabel = t('progressStepper.details');
    const reviewLabel = t('progressStepper.review');
    const confirmLabel = t('progressStepper.confirm');
    const completedNonVisualInfoText = t('progressStepper.completedStep');
    const currentNonVisualInfoText = t('progressStepper.currentStep');
    const upcomingNonVisualInfoText = t('progressStepper.upcomingStep');
    const PaymentStepsMap = {
        details: [
            {
                label: detailsLabel,
                status: 'active',
                nonVisualInfo: currentNonVisualInfoText
            },
            {
                label: reviewLabel,
                status: 'upcoming',
                nonVisualInfo: upcomingNonVisualInfoText
            },
            {
                label: confirmLabel,
                status: 'upcoming',
                nonVisualInfo: upcomingNonVisualInfoText
            }
        ],
        review: [
            {
                label: detailsLabel,
                status: 'completed',
                nonVisualInfo: completedNonVisualInfoText
            },
            {
                label: reviewLabel,
                status: 'active',
                nonVisualInfo: currentNonVisualInfoText
            },
            {
                label: confirmLabel,
                status: 'upcoming',
                nonVisualInfo: upcomingNonVisualInfoText
            }
        ],
        confirm: [
            {
                label: detailsLabel,
                status: 'completed',
                nonVisualInfo: completedNonVisualInfoText
            },
            {
                label: reviewLabel,
                status: 'completed',
                nonVisualInfo: completedNonVisualInfoText
            },
            {
                label: confirmLabel,
                status: 'completed',
                nonVisualInfo: currentNonVisualInfoText
            }
        ]
    };
    if (!PaymentStepsMap[step]) {
        throw new Error('missing step data');
    }
    return (_jsx(StepperWrapper, { children: _jsx(Stepper, { statusIcon: {
                completed: _jsx(FontAwesomeIcon, { icon: FAR_CHECK, size: "1x" })
            }, steps: PaymentStepsMap[step] }) }));
};
export default PaymentStepper;
